import { cn } from '@/lib/utils'

export const Headline = () => {
  return (
    <div
      className={cn(
        'max-w-[515px]',
        'text-balance text-[32px] font-semibold leading-[40px] tracking-[-0.48px] text-foreground'
      )}
    >
      Create an account and start your 14-day free trial on any subscription plan.
    </div>
  )
}
